import React, { useEffect, useState } from "react";
import { api_url, titleDescription } from "../../config/Config";
import 'react-responsive-modal/styles.css';
import _fetch from "../../config/api";
import toasted from "../../config/toast";
import { useTranslation } from 'react-i18next';
import { ColorRing } from "react-loader-spinner";

const TradeTransfer = (props: any) => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${props.pageTitle} | ${titleDescription}`;
    });

    const [amount, setAmount] = useState();
    const [username, setUsername] = useState('');
    const [trxPassword, setTRXPassword] = useState('');
    const [btnDisable, setbtnDisable] = useState(false);
    const [balance, setBalance] = useState(0);
    const [depositBalance, setDepositBalance] = useState(0);
    const [loading, setLoading] = useState(true);
    const [findedUserName, SetfindedUserName] = useState();

    useEffect(() => {
        getBalance();
    }, []);

    const getBalance = async () => {
        setLoading(true);
        const data = await _fetch(`${api_url}investment/getFundBalance`, "GET", {}, {});

        if (data?.status === 'success') {
            setLoading(false);
            setBalance(data?.data);
            setDepositBalance(data?.totalDepositAmount);
        }
    }

    const TransferTrade = async () => {
        setLoading(true);
        setbtnDisable(true);
        let data = {
            "username": username,
            "amount": amount,
            "trxpassword": Number(trxPassword)
        }
        let res = await _fetch(`${api_url}investment/trade-transfer`, "POST", data);
        if (res?.status === 'success') {
            toasted.success(res?.message);
            setLoading(false);
            setbtnDisable(false);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
        else {
            toasted.error(res?.message);
            setLoading(false);
            setbtnDisable(false);
        }
    }

    const checkUser = async (user_id: any) => {
        let res = await _fetch(`${api_url}auth/checkUser?user=${user_id}`, "GET", {})
        if (res?.status === "success") {
            SetfindedUserName(res?.data?.name);
        }
    }

    return (
        <>
            <main>
                <div className="buy_section loader_main">
                    {loading &&
                        <div className="spinner_bg">

                            <div className="color_ring">  <ColorRing
                                visible={true}
                                height="80"
                                width="80"

                                ariaLabel="blocks-loading"
                                wrapperStyle={{}}
                                wrapperClass="blocks-wrapper"
                                colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                            /></div>

                        </div>
                    }
                    <div className="coustom_container">
                        <div className="buy_top_sec">
                            <h4>
                                {t("TRADE DEPOSIT")}
                            </h4>
                            <div className="inner_data">
                                <p className="">{t("Deposit Balance")} : ${Number(depositBalance)?.toFixed(2)}</p>
                                <p className="">{t("Total Balance")} : ${Number(balance)?.toFixed(2)}</p>
                            </div>
                        </div>
                        <div className="row cards_sec">
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="card christmas_card mb-4">
                                    <div className="card-body">
                                        <div className="card_bottom_Sec">
                                            <div className="buy-section">
                                                <p className="select_amount">
                                                    <input type="text" placeholder='Enter Username' onChange={(e: any) => { setUsername(e.target.value); checkUser(e.target.value) }} value={username} />
                                                    <span className="text-success">{findedUserName}</span>
                                                </p>
                                                <p className="select_amount">
                                                    <input type="number" placeholder='Enter Amount' onChange={(e: any) => setAmount(e.target.value)} value={amount} />
                                                </p>
                                                <p className="select_amount">
                                                    <input type="number" placeholder='Enter Trx Password' onChange={(e: any) => setTRXPassword(e.target.value)} value={trxPassword} />
                                                </p>
                                                <button className="button_style w-100 mt-3" onClick={() => TransferTrade()} disabled={btnDisable}>
                                                    {`${t("Deposit")}`}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default TradeTransfer;
